module.exports = __webpack_public_path__ + "assets/ergIcon2.8a3f027c.svg";